import { isNavItemActive, type NavGroup } from '../model';
import { SidebarNavigationItem } from './SidebarNavigationItem';

type Props = {
  group: NavGroup;
  pathname: string;
  collapsed: boolean;
  onItemClick?: () => void;
};

const SidebarNavigationGroup = ({
  group,
  pathname,
  collapsed,
  onItemClick,
}: Props) => {
  return (
    <div className="flex flex-col gap-px">
      {group.title && !collapsed && (
        <span className="p6 text-secondary pl-[1rem] h-[1.8rem]">
          {group.title}
        </span>
      )}

      {group.items.map(({ key, onClick, ...item }) => (
        <SidebarNavigationItem
          key={key}
          {...item}
          collapsed={collapsed}
          isActive={!item.disabled && isNavItemActive(item, pathname)}
          onClick={() => {
            onClick?.();
            onItemClick?.();
          }}
        />
      ))}
    </div>
  );
};

export { SidebarNavigationGroup };
